import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { RootState } from '../app/store';

interface NormalRouteProps {
  component: React.FunctionComponent;
  exact?: boolean;
  path: string;
}

export default function NormalRoute({
  component: Component,
  ...props
}: NormalRouteProps) {
  const { user } = useSelector((state: RootState) => state.userProfile);

  if (user) {
    return <Redirect to="/" />;
  }
  return (
    <Route {...props}>
      <Component />
    </Route>
  );
}
